var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("tr", [
    _c("td", [
      _c("div", { staticClass: "form-field" }, [
        _c(
          "div",
          { staticClass: "file-upload-field" },
          [
            _c("file-upload", {
              attrs: { id: _vm.id, defaultImage: _vm.defaultImage },
              model: {
                value: _vm.modelValue.imagen,
                callback: function($$v) {
                  _vm.$set(_vm.modelValue, "imagen", $$v)
                },
                expression: "modelValue.imagen"
              }
            })
          ],
          1
        )
      ])
    ]),
    _vm._v(" "),
    _c("td", [
      _c(
        "button",
        {
          staticClass: "btn-danger",
          attrs: { type: "button" },
          on: { click: _vm.eliminar }
        },
        [_c("i", { staticClass: "fa fa-trash" })]
      )
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-8f08bae8", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-8f08bae8","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/element/TrFoto.vue
// module id = 606
// module chunks = 0